import { IconCheck } from '@vtex/shoreline'

interface UseSelectSearchableProps {
  isDisabled?: boolean
  isSelected?: boolean
  isFocused?: boolean
}

export function useSelectSearchable({
  isDisabled = false,
  isSelected = false,
  isFocused = false
}: UseSelectSearchableProps) {
  function getBackgroundColor(
    isDisabled: boolean,
    isSelected: boolean,
    isFocused: boolean
  ): string {
    if (isDisabled) return 'var(--sl-bg-base-disabled)'
    if (isSelected && !isFocused) return 'var(--sl-bg-base)'
    if (isFocused) return 'var(--primary)'

    return 'var(--sl-bg-base)'
  }

  function getTextColor(
    isDisabled: boolean,
    isSelected: boolean,
    isFocused: boolean
  ): string {
    if (isSelected && !isFocused) return 'var(--sl-fg-base)'
    if (isFocused && !isDisabled) return 'var(--sl-fg-inverted)'

    return 'var(--sl-fg-base)'
  }

  const optionStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px',
    margin: '2px 0',
    borderRadius: 'var(--sl-radius-2)',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    backgroundColor: getBackgroundColor(isDisabled, isSelected, isFocused),
    color: getTextColor(isDisabled, isSelected, isFocused)
  }

  const OptionIcon = isSelected ? (
    <IconCheck
      style={{
        color:
          isFocused && !isDisabled ? 'var(--sl-fg-inverted)' : 'var(--primary)'
      }}
    />
  ) : (
    <div style={{ minWidth: '1.25rem' }} />
  )

  return {
    optionStyles,
    OptionIcon
  }
}
